import { StraightenOutlined } from '@mui/icons-material'
import { IconButton, Tooltip } from '@mui/material'
import { LocalizedTypography } from 'components/Localization/LocalizedTypography'
import { useEffect, useState } from 'react'
import { MeasurementMode } from '../manager/InputHandlers/MeasurementsManager'
import { ModelController } from '../manager/ModelController'
import { CadexMeasurementHelpText } from './LeftButtonIcon'

export const DistanceMeasurementTool = (props: {
  controller: ModelController
  setHelpComponent: (component: React.ReactElement<any>) => void
}) => {
  const [active, setActive] = useState(false)

  useEffect(() => {
    props.controller.onMeasurentModeChanged((mode) => {
      setActive(mode === MeasurementMode.TwoPointDistance)
    })
  }, [props.controller])

  const handleClick = () => {
    if (active) {
      props.controller.resetMeasurement()
      setActive(false)
      props.setHelpComponent(undefined)
    } else {
      props.controller.enableDistanceMeasurement()
      setActive(true)
      props.setHelpComponent(
        <CadexMeasurementHelpText
          measurementMode={MeasurementMode.TwoPointDistance}
        />,
      )
    }
  }

  return (
    <Tooltip
      title={<LocalizedTypography translationKey="project:viewer-distance" />}
    >
      <IconButton
        size="small"
        onClick={handleClick}
        color="inherit"
        sx={{
          backgroundColor: active ? 'primary.main' : 'transparent',
          color: active ? 'white' : 'inherit',
          '&:hover': {
            backgroundColor: active ? 'primary.main' : 'transparent',
            color: active ? 'white' : 'inherit',
          },
        }}
      >
        <StraightenOutlined fontSize="small" />
      </IconButton>
    </Tooltip>
    // <ToolButton onClick={handleClick} active={active}>
    //   <StraightenOutlined />
    //   <LocalizedTypography
    //     translationKey="project:viewer-distance"
    //     variant="body2"
    //     component="p"
    //   >
    //     distance
    //   </LocalizedTypography>
    // </ToolButton>
  )
}
